import React from "react";
import styled from "@emotion/styled";
import { CrIcon } from "@maven-surface/components/base/CrIcon";

const StyledHamburgerButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: #259ac5;

  i {
    height: 100%;
    display: block;
    font-size: x-large;
    color: #ffffff;
  }
`;

interface HamburgerButtonProps {
  onClick?: () => void;
}

export const HamburgerButton = ({ onClick }: HamburgerButtonProps) => {
  return (
    <StyledHamburgerButton onClick={() => onClick && onClick()}>
      <CrIcon icon={{ package: "MATERIAL", name: "menu" }} />
    </StyledHamburgerButton>
  );
};
